import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { timeout, map } from 'rxjs/operators';

const mainUrl = environment.url;

@Injectable({
  providedIn: 'root'
})
export class CityService {

  constructor(private http: HttpClient) { }

  getAllCities(): Observable<any> {
    return this.http.get(mainUrl + 'param-city')
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  getAllCitiesPaged(size: string | null, page: string | null): Observable<any> {
    let params: HttpParams;
    let desc = 'id, desc';

    if (size || page) {
      params = new HttpParams({
        fromObject: {
          'size': size || null,
          'page': page || null,
          'short' : desc
        }
      })
    } else {
      params = new HttpParams()
    }
    return this.http.get(mainUrl + 'param-city/paged', { params: params })
  }

  createCity(form): Observable<any> {
    return this.http.post(mainUrl + 'param-city', form)
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  getCityById(id): Observable<any> {
    return this.http.get(mainUrl + 'param-city/' + id)
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  updateCity(id, form): Observable<any> {
    return this.http.put(mainUrl + 'param-city/' + id, form)
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  deleteCity(id): Observable<any> {
    return this.http.delete(mainUrl + 'param-city/' + id)
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  getHeader() {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': window.localStorage.getItem('token')
     });

    return headers;
  }
}
